import gql from 'fake-tag'
import { cache } from 'services'
import { ContactForm } from 'types/contentful'

import { captureException } from '../../error-tracking'

import DefaultClient from './DefaultClient'

class ContactClient extends DefaultClient {
    constructor() {
        super(cache.keys.CONTACT_FORM)
    }

    async getTopics(lang = 'en'): Promise<ContactForm.Topic[]> {
        const locale = this.getLocale(lang)
        const cacheKey = `TOPICS_${locale}`
        const cache = this.cache.get(cacheKey)
        if (cache) return cache

        const query = gql`
            {
                twContactFormTopicCollection(preview: ${this.isPreview}, order: position_ASC) {
                    items {
                        slug
                        name: name(locale: "${locale}")
                        position
                        image {
                            alt: title(locale: "${locale}")
                            url
                        }
                        zendeskId
                        message: message(locale: "${locale}")
                        resultMessage: resultMessage(locale: "${locale}")
                    }
                }
            }
        `

        try {
            const data = await this.queryGraphQL(query)
            if (!data) {
                console.error('Receiving empty response from Contentful.')
                captureException(new Error('Receiving empty response from Contentful.'))
                return []
            }
            // Preview content can include blank or half-finished drafts, which can't be rendered.
            const topics = data.twContactFormTopicCollection.items.filter(
                (topic: ContactForm.Topic | null) => topic?.slug && topic.name && topic.image?.url,
            )
            this.cache.set(cacheKey, topics)

            return topics
        } catch (error) {
            const { message } = error as Error
            console.error(`Contentful request failed: ${message}`)
            captureException(`Contentful request failed: ${message}`)

            return []
        }
    }
}

export default new ContactClient()
